import React, {useContext} from 'react';
import {useIntl} from "react-intl";
import moment from "moment";

import {DateRangePickerContext} from "contexts/DateRangePickerContext";

import {UserAgentUtils} from "utils/useragent";

function DashboardDateMessage(props) {
    const intl = useIntl();

    const {startDate, endDate} = useContext(DateRangePickerContext)

    const startDateYear = moment(startDate).format('YYYY');
    const endDateYear = moment(endDate).format('YYYY');

    let startDateLabel = intl.formatDate(startDate, { day: "numeric", month: "long" });
    let endDateLabel = intl.formatDate(endDate, { day: "numeric", month: "long" });

    if (startDateYear !== endDateYear) {
        startDateLabel = intl.formatDate(startDate, { day: "numeric", month: "long", year: "numeric" });
        endDateLabel = intl.formatDate(endDate, { day: "numeric", month: "long", year: "numeric"  });
    }

    const dateLabel = intl.formatDate(new Date(), { day: "numeric", month: "long" });

    return (
        <div style={{ fontSize: UserAgentUtils.isMobile() ? '13px' : "16px", color: "#666F7E", marginTop: "4px" }}>
            {intl.formatMessage(
                { id: "dashboard.subtitle" },
                { date: dateLabel, startDate: startDateLabel, endDate: endDateLabel }
            )}
        </div>
    );
}

export default DashboardDateMessage;
